import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { faEdit, faDownload, faSliders, faAngleDown, faAngleUp, faCloudUploadAlt, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { MessageService } from 'src/app/share/sharedsubject';

import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { MessageModalComponent } from 'src/app/share/components/message-modal/message-modal.component';
import { EditReasonModalComponent } from 'src/app/share/components/edit-reason-modal/edit-reason-modal.component';

@Component({
    selector: 'app-product-list',
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.scss'],
    standalone: false
})

export class ProductListComponent implements OnInit, OnDestroy {
  private readonly searchSubject$ = new Subject<void>();
  private searchSubscription!: Subscription;
  private stockInSub?: Subscription;
  private readonly subscription: Subscription;

  company2: any[]=[];
  endOfResults: boolean=false;
  pageNumber: number=0;
  loader : boolean = false;
  errorMessage : any;
  filterPendingInvoice: boolean= false;
  message: any;
  companyData: any[];
  filters: any = {};
  isImageVoucher: boolean = false;
  selectedVocher: { url: any, rawUrl: string, name: any } = { url: '', rawUrl: '', name: '' };
  
  showFilterPanel: boolean = false;
  purchaseTypes = [
    { label: 'Import from dealer', value: 'ImportFromDealer' },
    { label: 'Import from sheet', value: 'ImportFromSheet' },
    { label: 'Return from customer', value: 'ReturnFromCustomer' },
    { label: 'Transfer from branch', value: 'TransferFromBranch' }
  ];

  filtersForm = {
    branch: null as string | null,
    tyreSize: '',
    tyreMake: '',
    tyreModel: '',
    stockInType: null as string | null
  };

  isBranchVisible: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly stockService: StockService,
    private readonly messageService: MessageService,
    private readonly companyService: CompanyServiceService,
    private readonly modalService: NgbModal,
    private readonly sanitizer: DomSanitizer,
    private readonly storageService: StorageService,
  )
  {
    this.subscription = this.messageService.getMessage().subscribe((message: any) => {
      if (message) {
        this.message = message.text;
        this.openMessageModal();
      }
    });
    let userDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.isBranchVisible = userDetails?.enrollmentType === 'Company';
  }

  isToday(dateStr: any): boolean {
    if (!dateStr) return false;
    try {
      const dateVal = new Date(dateStr);
      if (Number.isNaN(dateVal.getTime())) return false;
      const orderDateStr = dateVal.toLocaleDateString('en-GB', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replaceAll('/', '-');
      const todayDateStr = new Date().toLocaleDateString('en-GB', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replaceAll('/', '-');
      return orderDateStr === todayDateStr;
    } catch (error) {
      const _ = error;
      return false;
    }
  }

  buildEditReason(stock: any[], reason: string): string {
    const lines: string[] = [];
    (stock || []).forEach((s: any) => {
      const identity = [s.tyreSize, s.tyreMake, s.tyreModel].filter(Boolean).join(' ');
      if (s.editedQuantity !== undefined && s.editedQuantity !== null) {
        lines.push(`${identity}, quantity changed from ${s.quantity} to ${s.editedQuantity}`);
      }
      if (s.editedPurchasingPrice !== undefined && s.editedPurchasingPrice !== null) {
        lines.push(`${identity}, purchase price changed from ${s.purchasingPrice} to ${s.editedPurchasingPrice}`);
      }
    });
    if (reason) lines.push(`With reason: ${reason}`);
    return lines.join('\n');
  }

  openReasonModal(order: any) {
    const modalRef = this.modalService.open(EditReasonModalComponent, { centered: true, size: 'md' });
    modalRef.componentInstance.fullReason = order.fullReason;
  }

  viewVoucher(data: any, model: any) {
    const invoiceUrl =  data.invoice;
    if (invoiceUrl) {
      const urlString = invoiceUrl.toLowerCase();
      this.isImageVoucher = urlString.endsWith('.jpg') || 
                            urlString.endsWith('.jpeg') || 
                            urlString.endsWith('.png') || 
                            urlString.endsWith('.gif') || 
                            urlString.endsWith('.webp');
      this.selectedVocher.url = this.sanitizer.bypassSecurityTrustResourceUrl(invoiceUrl);
      this.selectedVocher.rawUrl = invoiceUrl;
      this.selectedVocher.name = data.invoiceNumber;
      this.modalService.open(model, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    }
  }

  ngOnInit(){
    this.searchSubscription = this.searchSubject$.pipe(
      debounceTime(300)
    ).subscribe(() => {
      this.onChangeApplyFilter();
    });

    this.getAllStockInDetails();
    this.getAllCompanyList();
  }

  getBadgeClass(type: string): string {
    const lowerType = (type || '').toLowerCase();
    if (lowerType.includes('dealer')) {
      return 'bg-purchase';
    } else if (lowerType.includes('sheet')) {
      return 'bg-purchase';
    } else if (lowerType.includes('transfer')) {
      return 'bg-transfer';
    } else if (lowerType.includes('return')) {
      return 'bg-return';
    } else if (lowerType.includes('adjustment')) {
      return 'bg-adjustment';
    } else {
      return 'bg-sale';
    }
  }

  getAllStockInDetails() {
    this.loader = true;
    let params = { ...this.filters, page: this.pageNumber };
    if (this.filterPendingInvoice) params.showPendingList = this.filterPendingInvoice;

    if (this.stockInSub) {
      this.stockInSub.unsubscribe();
    }

    this.stockInSub = this.stockService.getAllStockIn(params).subscribe({
      next: (res: any) => {
        const newData = (res.data || []).map((item: any) => this.processItem(item));
        this.company2 = this.company2.concat(newData);
        if (res.data.length === 0) {
          this.endOfResults = true;
        }
        this.loader = false;
      },
      error: (error: any) => {
        this.errorMessage = error?.error?.error?.message;
        this.loader = false;
      }
    });
  }

  processItem(item: any) {
    item.badgeClass = this.getBadgeClass(item.stockInType);

    const type = (item.stockInType || '').toLowerCase();
    const canEditBase = (type === 'importfromdealer');
    item.hasEditAction = canEditBase;

    if (item.stock && Array.isArray(item.stock)) {
      item.stock = item.stock.map((s: any) => {
        s.finalQuantity = s.editedQuantity ?? s.quantity ?? null;
        s.finalUnitPrice = s.editedPurchasingPrice ?? s.purchasingPrice ?? null;
        return s;
      });
    }

    item.fullReason = (canEditBase && item.isEdited) ? this.buildEditReason(item.stock, item.reason) : '';

    if (canEditBase) {
      const isPending = !!(item.isUploadInvoiceCheckbox && !item.invoice);
      const isToday = this.isToday(item.created);
      const canEditTx = this.isBranchVisible || isToday;
      const isEdited = !!item.fullReason;

      item.isPendingInvoice = isPending;
      item.showPrimaryButton = isPending || !isEdited;
      item.disablePrimaryButton = !isPending && !isEdited && !canEditTx;

      item.buttonTooltip = this.getButtonTooltip(item);

      item.queryParams = this.getQueryParams(item, isPending, isEdited, canEditTx);
    }

    if (item.created) {
      const createdDate = new Date(item.created);
      item.formattedDateStr = createdDate.toLocaleDateString('en-GB', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replaceAll('/', '-');
      item.formattedTimeStr = createdDate.toLocaleTimeString('en-GB', {
        timeZone: 'Asia/Kolkata',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }).toUpperCase();
      item.formattedCreated = `${item.formattedDateStr} ${item.formattedTimeStr}`;
    }

    return item;
  }

  getButtonTooltip(item: any): string {
    const isPending = !!(item.isUploadInvoiceCheckbox && !item.invoice);
    const isToday = this.isToday(item.created);
    const canEditTx = this.isBranchVisible || isToday;
    const isEdited = !!item.fullReason;

    if (isPending && isEdited) {
      return 'Upload Invoice';
    } else if (isPending && canEditTx) {
      return 'Upload Invoice / Edit Transaction';
    } else if (isPending && !canEditTx) {
      return "Upload Invoice (Branch users can only edit today's transactions)";
    } else if (!isPending && !isEdited && canEditTx) {
      return 'Edit Transaction';
    } else if (!isPending && !isEdited && !canEditTx) {
      return "Branch users can only edit today's transactions";
    }
    return '';
  }

  private getQueryParams(item: any, isPending: boolean, isEdited: boolean, canEditTx: boolean): any {
    if (isPending) {
      if (isEdited || !canEditTx) {
        return { udid: item._id };
      }
      return { id: item._id };
    }
    if (!isEdited) {
      if (canEditTx) {
        return { editId: item._id };
      }
    }
    return null;
  }

  editPurchase(item: any) {
    if (item?.queryParams) {
      this.router.navigate(['/new-product'], { queryParams: item.queryParams });
    }
  }

  onScroll(){
    if(this.endOfResults || this.loader){
      return;
    }
    this.pageNumber++;
    this.getAllStockInDetails();
  }

  invoiceFilterList(checkInvoice:any){
    this.filterPendingInvoice = checkInvoice.target.checked;
    this.onChangeApplyFilter();
  }

  openMessageModal() {
    const modalRef = this.modalService.open(MessageModalComponent, {
      centered: true,
      backdrop: 'static',
      size: 'md'
    });
    modalRef.componentInstance.message = this.message;
  }


  getAllCompanyList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      this.companyData = (res.data|| []).filter((company: any) => company.status === 'Active');
    });
  }

  onTextInputChange() {
    this.searchSubject$.next();
  }

  onChangeApplyFilter() {
    this.pageNumber = 0;
    this.endOfResults = false;
    if (this.stockInSub) {
      this.stockInSub.unsubscribe();
    }
    this.company2 = [];
    this.filters = Object.fromEntries(
      Object.entries(this.filtersForm).filter(
        ([key, value]) => value !== '' && value !== null && value !== 'all'
      )
    );
    
    this.getAllStockInDetails();
  }

  openFilterPanel() {
    this.showFilterPanel = !this.showFilterPanel;
  }

  trackById(index: number, item: any) {
    return item ? item._id : index;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.stockInSub) {
      this.stockInSub.unsubscribe();
    }
  }

  protected readonly faEdit = faEdit;
  protected readonly faInfoCircle = faInfoCircle;
  protected readonly faUpload = faCloudUploadAlt;
  protected faDownload = faDownload;
  protected readonly faSliders = faSliders;
  protected readonly faAngleDown = faAngleDown;
  protected readonly faAngleUp = faAngleUp;
}
